import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";

@Component({
  selector: "scaffold-switch",
  templateUrl: "./switch.component.html",
  styleUrls: ["../../rendered.component.scss", "./switch.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  switchValue;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  update() {
    this.switchValue = this.value;
    this.cdr.detectChanges();
  }
  updateSwitch() {
    this.change.emit({ value: this.switchValue });
  }
  checkDisable() {
    if(this.item.ignore_prevent_edit && !this.item?.disabled){
      return false;
    }
    return this.renderedService.isDisabled(this.info.type) || this.item?.disabled;
  }
}
